// extracted by mini-css-extract-plugin
export default {"header":"Header_header__PmyoG","content":"Header_content__RGB4f","links":"Header_links__z3oH-","link":"Header_link__mFM5k","linksOpened":"Header_linksOpened__CdPZr"};